module.exports = __webpack_public_path__ + "img/icon-download.30061a25.svg";